import { jsxs as e, jsx as n } from "react/jsx-runtime";
function r({ message: t }) {
  return typeof t.data == "object" && t.data != null && "rating" in t.data && typeof t.data.rating == "number" ? /* @__PURE__ */ e("div", { className: "mt-2 flex animate-fadeIn items-center self-start rounded-medium bg-background px-5 py-4 text-sm leading-[1.5]", children: [
    /* @__PURE__ */ n("strong", { children: "User feedback:" }),
    " ",
    t.data.rating > 0 ? "Helpful" : "Not helpful"
  ] }) : null;
}
export {
  r as BotFeedback
};
